import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import style from "./Separator.style";

const Separator = ({
  className,
  attributes
}) => ___EmotionJSX("hr", _extends({
  css: style.separator,
  className: className
}, attributes));

Separator.defaultProps = {
  className: undefined,
  attributes: {}
};
Separator.propTypes = {
  className: PropTypes.string,
  attributes: PropTypes.object
};
export default Separator;